let backTop = {
    init() {

        $('.backTop').click( function() { // Au clic sur un Ã©lÃ©ment
            var page = $(this).attr('href'); // Page cible
            var speed = 750; // DurÃ©e de l'animation (en ms)
            $('html, body').animate( { scrollTop: $(page).offset().top }, speed ); // Go
            return false;
        });



        $(window).scroll(function() {
            if ($(this).scrollTop() > 130) {
                $(".backTop").addClass('active');
            } else {
                $(".backTop").removeClass('active');
            }
        });

    }
}

export default backTop;
